/**
 * JSON Viewer Component
 *
 * Renders JSON with syntax highlighting and collapsible sections.
 */

interface JsonViewerProps {
  data: unknown;
  maxHeight?: number;
}

export function JsonViewer({ data, maxHeight }: JsonViewerProps) {
  const json = JSON.stringify(data, null, 2);

  return (
    <pre
      style={{
        maxHeight: maxHeight ?? 400,
        overflow: 'auto',
      }}
    >
      {json}
    </pre>
  );
}

/**
 * Inline code display.
 */
export function Code({ children }: { children: React.ReactNode }) {
  return (
    <code
      className="mono"
      style={{
        background: '#f5f5f5',
        padding: '2px 6px',
        borderRadius: 4,
        fontSize: 13,
      }}
    >
      {children}
    </code>
  );
}
